
import {
    useState
} from 'react';
import ElementFrame from '../utils-components/ElementFrame';

import '../component.css';

import process_vars from '../intermediate/process_vars';

import ScriptView from '../script/ScriptView';
import PropSection from '../utils-components/PropSection';

const math = require('mathjs');

// processes label's text, performs relevant arithmetic, and replaces variable values
// (String text, Map vars) -> String parsedText
function renderLabelText(text, vars) {
    let parsedText = text;

    let mathRegex = /\[(.*?)\](\d*)f(\d*)/g;
    let matchResults = [...parsedText.matchAll(mathRegex)];
    matchResults.forEach(result => {
        let mathExp = process_vars(result[1], vars);
        let evaluatedExp = 0;
        try {
            evaluatedExp = math.evaluate(mathExp).toString();
            if (result[3] != null) {
                evaluatedExp = parseFloat(evaluatedExp).toFixed(parseInt(result[3]));
            }
        } catch (e) {
            // do nothing
        }
        parsedText = parsedText.replace(result[0], evaluatedExp);
    });

    parsedText = process_vars(parsedText, vars);
    return parsedText;
}

export default function Label({ id, comps, setter, vw, gridSize, sel, setSel, hov, setHov, vars, setVars, contextMenu, setContextMenu, pdf, magneticGrid, setMagneticGrid, magneticGridPartitions }) {

    let background_color = '';
    if (hov === id) {
        background_color = '#e8f1ff';
    } else {
        background_color = process_vars(comps[id].props.backgroundColor, vars);
    }

    let innerContent = <></>;
    if (sel === id) {
        background_color = process_vars(comps[id].props.backgroundColor, vars);
        innerContent = <div style={{
            textAlign: process_vars(comps[id].props.alignment, vars),
            width: '98%'
        }}><input className='view-input' onClick={(e) => {
            e.stopPropagation();
        }} onDoubleClick={(e) => {
            e.target.select();
        }} onChange={(e) => {
            e.stopPropagation();
            let new_comps = [...comps];
            new_comps[id].props.text = e.target.value;
            setter(new_comps);
        }} value={comps[id].props.text} style={{
            fontSize: process_vars(comps[id].props.fontSize, vars) + 'vmax',
            color: process_vars(comps[id].props.color, vars),
            backgroundColor: background_color,
            fontWeight: process_vars(comps[id].props.bold, vars) ? '700' : '400',
            fontStyle: process_vars(comps[id].props.italic, vars) ? 'italic' : '',
            textDecoration: process_vars(comps[id].props.underlined, vars) ? 'underline' : '',
            textAlign: process_vars(comps[id].props.alignment, vars)
        }} /></div>
    } else {
        innerContent = <div style={{
            textAlign: process_vars(comps[id].props.alignment, vars),
            width: '98%',
            overflowWrap: "break-word"
        }}>{renderLabelText(comps[id].props.text, vars)}</div>;
    }

    return (
        <div>
            {
                pdf == true ? (<div
                    style={{
                        textAlign: process_vars(comps[id].props.alignment, vars),
                        width: '98%',
                        overflowWrap: "break-word",
                        zIndex: '0',
                        border: process_vars(comps[id].props.borderEnabled, vars) ?
                            `${process_vars(comps[id].props.borderColor, vars)} solid ${process_vars(comps[id].props.borderWidth)}pt` : '#000 solid 0px',

                        // textAlign: 'center',
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: process_vars(comps[id].props.fontSize, vars) + 'vmax',
                        fontWeight: process_vars(comps[id].props.bold, vars) ? '700' : '400',
                        fontStyle: process_vars(comps[id].props.italic, vars) ? 'italic' : '',
                        textDecoration: process_vars(comps[id].props.underlined, vars) ? 'underline' : '',

                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: process_vars(comps[id].size[0], vars) * vw,
                        height: process_vars(comps[id].size[1], vars) * vw,
                        transform: `translate(${process_vars(comps[id].position[0], vars) * vw}px, ${process_vars(comps[id].position[1], vars) * vw}px)`,
                        color: process_vars(comps[id].props.color, vars),
                        backgroundColor: background_color,
                    }}>
                    {renderLabelText(comps[id].props.text, vars)}
                </div>) : (
                    <ElementFrame id={id} comps={comps} setter={setter} vw={vw}
                        gridSize={gridSize} vars={vars} setSel={setSel} setHov={setHov}
                        setContextMenu={setContextMenu} magneticGrid={magneticGrid}
                        magneticGridPartitions={magneticGridPartitions} preset="small"
                        style={{
                            color: process_vars(comps[id].props.color, vars),
                            backgroundColor: background_color,
                            textAlign: 'center',
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: 'hidden',
                            fontSize: process_vars(comps[id].props.fontSize, vars) + 'vmax',
                            fontWeight: process_vars(comps[id].props.bold, vars) ? '700' : '400',
                            fontStyle: process_vars(comps[id].props.italic, vars) ? 'italic' : '',
                            textDecoration: process_vars(comps[id].props.underlined, vars) ? 'underline' : '',
                            zIndex: '0',
                            border: process_vars(comps[id].props.borderEnabled, vars) ?
                                `${process_vars(comps[id].props.borderColor, vars)} solid ${process_vars(comps[id].props.borderWidth)}pt` : '#000 solid 0px',
                            transition: 'transform 0.05s ease'
                        }}>{innerContent}</ElementFrame>
                )
            }
        </div>
    );

}

export function LabelProperties({ id, comps, setter, setSel, vars, setVars, externals, setExternals, creationIndex, setCreationIndex }) {

    const [isShowingScript, setIsShowingScript] = useState(false);

    let csvDefault = false;
    try {
        if (comps[id].props.hasOwnProperty('appearsInCSV')) {
            csvDefault = comps[id].props.appearsInCSV;
        }
    } catch (e) {
        // do nothing
    }


    return (<>
        <div className="prop-actions">
            <a className='panel-button' onClick={(e) => {
                e.preventDefault();
                setIsShowingScript(true);
            }}>Edit Script</a>
        </div>

        <PropSection title="Layout">
            <p className='panel-label'>Position: </p>
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].position[0] = e.target.value;
                setter(new_comps);
            }} value={comps[id].position[0]} style={{ width: '25%' }} placeholder='X' />
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].position[1] = e.target.value;
                setter(new_comps);
            }} value={comps[id].position[1]} style={{
                width: '25%',
                marginLeft: '0.5vmax'
            }} placeholder='Y' />
            <br /> <br />
            <p className='panel-label'>Dimensions: </p>
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].size[0] = e.target.value;
                setter(new_comps);
            }} value={comps[id].size[0]} style={{ width: '25%' }} placeholder='Width' />
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].size[1] = e.target.value;
                setter(new_comps);
            }} value={comps[id].size[1]} style={{
                width: '25%',
                marginLeft: '0.5vmax'
            }} placeholder='Height' />
        </PropSection>

        <PropSection title="Content">
            <p className='panel-label'>Appears in CSV: </p>
            <input type="checkbox" checked={csvDefault} onClick={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.appearsInCSV = !new_comps[id].props.appearsInCSV;
                setter(new_comps);
            }}></input>
        </PropSection>

        <PropSection title="Text">
            <p className='panel-label'>Size: </p>
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.fontSize = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.fontSize} />
            <br /> <br />
            <p className='panel-label'>Style: </p>
            <i className={'fa fa-solid fa-bold panel-icon' + (comps[id].props.bold ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.bold = !new_comps[id].props.bold;
                setter(new_comps);
            }}></i>
            <i className={'fa fa-solid fa-italic panel-icon' + (comps[id].props.italic ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.italic = !new_comps[id].props.italic;
                setter(new_comps);
            }}></i>
            <i className={'fa fa-solid fa-underline panel-icon' + (comps[id].props.underlined ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.underlined = !new_comps[id].props.underlined;
                setter(new_comps);
            }}></i>
            <br /> <br />
            <p className='panel-label'>Alignment: </p>
            <i className={'fa fa-solid fa-align-left panel-icon' + (comps[id].props.alignment === 'left' ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.alignment = 'left';
                setter(new_comps);
            }}></i>
            <i className={'fa fa-solid fa-align-center panel-icon' + (comps[id].props.alignment === 'center' ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.alignment = 'center';
                setter(new_comps);
            }}></i>
            <i className={'fa fa-solid fa-align-right panel-icon' + (comps[id].props.alignment === 'right' ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.alignment = 'right';
                setter(new_comps);
            }}></i>
            <br /> <br />
            <p className='panel-label'>Text Color: </p>
            <input className='panel-input' style={{
                width: '17.5%',
                marginRight: '0.75vmax'
            }} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.color = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.color} />
            <p className='panel-label'>or</p>
            <input type='color' className='panel-color-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.color = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.color} />
        </PropSection>

        <PropSection title="Appearance">
            <p className='panel-label'>Background Color: </p>
            <input className='panel-input' style={{
                width: '17.5%',
                marginRight: '0.75vmax'
            }} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.backgroundColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.backgroundColor} />
            <p className='panel-label'>or</p>
            <input type='color' className='panel-color-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.backgroundColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.backgroundColor} />
        </PropSection>

        <PropSection title="Border">
            <p className='panel-label'>Border Enabled: </p>
            <input type="checkbox" checked={comps[id].props.borderEnabled} onClick={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderEnabled = !new_comps[id].props.borderEnabled;
                setter(new_comps);
            }}></input>
            <br /><br />
            <p className='panel-label'>Border Color: </p>
            <input className='panel-input' style={{
                width: '17.5%',
                marginRight: '0.75vmax'
            }} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.borderColor} />
            <p className='panel-label'>or</p>
            <input type='color' className='panel-color-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.borderColor} />
            <br /><br />
            <p className='panel-label'>Border Width:</p>
            <input type='range' min='1' max='10' value={comps[id].props.borderWidth} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderWidth = parseInt(e.target.value);
                setter(new_comps);
            }}></input>
        </PropSection>

        <div className="prop-footer">
            <a className='panel-button' onClick={(e) => {
                e.preventDefault();
                setSel(-1);
            }}>Ok</a>
            <a className='panel-button prop-danger' onClick={(e) => {
                e.preventDefault();
                let new_comps = [...comps];
                new_comps.splice(id, 1);
                setSel(-1);
                setter(new_comps);
            }}>Delete</a>
        </div>

        {isShowingScript ? <ScriptView id={id} comps={comps} setComps={setter}
            setIsShowingScript={setIsShowingScript}
            vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
            creationIndex={creationIndex} setCreationIndex={setCreationIndex} /> : <></>}
    </>);

}

export function LabelAdder({ comps, setComps, setView, page, pageId, setSelectedEl, creationIndex, setCreationIndex }) {

    const [hovered, setHovered] = useState(false);

    return (
        <div className="toolbar-element" style={{
            // border: '1px #FAF3DD solid',
            // display: 'inline-block',
            // padding: '1vmax',
            // color: '#1f2933',
            // backgroundColor: hovered ? '#FAF3DD' : 'black',
            // transition: 'background-color 0.1s, color 0.1s',
            // marginLeft: '1vmax'
        }} onMouseEnter={() => {
            setHovered(true);
        }} onMouseLeave={() => {
            setHovered(false);
        }} onClick={(e) => {
            e.preventDefault();
            let new_comps = [...comps];
            new_comps.push({
                page: page,
                page_id: pageId,
                type: 'primitive/Label',
                name: 'Label',
                ...(creationIndex != -1 && {creation_index: creationIndex}),
                position: [0.475, 0.15 + document.getElementById("wrapper").scrollTop / document.getElementById("wrapper").offsetWidth],
                size: [0.10, 0.05],
                props: {
                    text: 'Label',
                    fontSize: 1,
                    bold: false,
                    italic: false,
                    underlined: false,
                    color: '#000000',
                    backgroundColor: '#ffffff',
                    alignment: 'center',
                    borderEnabled: true,
                    borderColor: '#000000',
                    borderWidth: 1
                }, script: [
                    {
                        type: "event/start",
                        children: []
                    },
                    {
                        type: "event/change",
                        children: []
                    },
                    {
                        type: "event/save",
                        children: []
                    }
                ],
                error: "",
                warning: "",
                disable: false
            });
            if (creationIndex != -1) {
                setCreationIndex(creationIndex + 1);
            }
            setComps(new_comps);
            setView('');
            setSelectedEl(comps.length);
        }}>
            <i className="fa fa-solid fa-tag" style={{
                color: '#475569'
            }}></i>
            <p className='panel-label' style={{
                color: '#1f2933',
                marginLeft: '1vmax',
                fontSize: '1.15vmax'
            }}>Label</p>
        </div>
    );

}